import React from 'react'
import { ReorderDialog } from 'components/common/drag-and-drop/reorder-dialog'
import {
  type ExecOrgDescendantItem,
  getExecutiveOrgChildren,
  reorderChildOrgs
} from 'services/executives/executiveOrgLookupService'

interface ExecutiveOrgChildrenReorderDialogProps {
  open: boolean
  onClose: () => void
  parentOrgId: number
  parentName?: string
  onReordered: () => void
}

export const ExecutiveOrgChildrenReorderDialog: React.FC<ExecutiveOrgChildrenReorderDialogProps> = ({
  open,
  onClose,
  parentOrgId,
  parentName,
  onReordered
}) => {
  const title = parentName != null && parentName !== ''
    ? `Reorder Child Offices of ${parentName}`
    : 'Reorder Child Offices'

  return (
    <ReorderDialog<ExecOrgDescendantItem>
      open={open}
      onClose={onClose}
      listId="exec-org-children-order"
      title={title}
      emptyText="No child offices to reorder"
      loadingText="Loading child offices..."
      savingText="Saving new order..."
      fetchErrorText="Failed to load child organizations. Please try again."
      saveErrorText="Failed to save the new order. Please try again."
      itemIdPrefix="exec-org-child"
      refetchKey={parentOrgId}
      fetchItems={async () => await getExecutiveOrgChildren(parentOrgId)}
      getCardText={(item) => item.name}
      onSave={async (orderedItems) => {
        const response = await reorderChildOrgs(parentOrgId, orderedItems.map(item => item.id))
        return { ...response, result: orderedItems }
      }}
      onSaved={() => { onReordered() }}
    />
  )
}
